const el = document.createElement('style');
document.head.appendChild(el);

export default class CoreStyler {
  constructor(parent) {
    this.$parent = parent;
  }

  get form() {
    const setting = this.$parent.model?.settings || {};
    return {
      main: setting.colorFormMain || '#1b2f3f',
      color: setting.colorFormColor || '#ffffff',
      input: setting.colorFormInput || '#333333',
      error: setting.colorFormError || '#ee1111',
      label: setting.colorFormLabel || '#777777',
      border: setting.colorFormBorder || '#999999',
      disable: setting.colorFormDisable || '#dddddd',
    };
  }

  get formStyle() {
    const s = this.form;
    let style = '';
    style += `.form-input{color: ${s.input};}`;
    style += `.form-input input{color: ${s.input};}`;
    style += `.form-input select{color: ${s.input};}`;
    style += `.form-item-btn{color: ${s.input};}`;
    return style;
  }

  set() {
    el.innerHTML = this.formStyle;
  }
}
